export default __webpack_public_path__ + "static/media/cmr_notes.86966e06.svg";